/* tslint:disable */
/* eslint-disable */
/**
 * Ameta hms API
 * A rest api for managing the ameta hms system
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RuhYearDataObject,
    RuhYearDataObjectFromJSON,
    RuhYearDataObjectFromJSONTyped,
    RuhYearDataObjectToJSON,
} from './';

/**
 * 
 * @export
 * @interface HMSCounterDataRuh
 */
export interface HMSCounterDataRuh {
    /**
     * 
     * @type {{ [key: string]: RuhYearDataObject; }}
     * @memberof HMSCounterDataRuh
     */
    years: { [key: string]: RuhYearDataObject; };
}

export function HMSCounterDataRuhFromJSON(json: any): HMSCounterDataRuh {
    return HMSCounterDataRuhFromJSONTyped(json, false);
}

export function HMSCounterDataRuhFromJSONTyped(json: any, ignoreDiscriminator: boolean): HMSCounterDataRuh {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'years': (mapValues(json['years'], RuhYearDataObjectFromJSON)),
    };
}

export function HMSCounterDataRuhToJSON(value?: HMSCounterDataRuh | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'years': (mapValues(value.years, RuhYearDataObjectToJSON)),
    };
}


